import { useState } from "react";
import { useStore, CAT_META } from "../store/Store";

// ─── SPOTLIGHT CARD ───────────────────────────────────────────────────────────
// Used only for "Featured by Matchwell". White card, thin gold frame, large
// clean photo, understated luxury — deliberately calmer than the other
// carousel styles so it reads as the premium/curated pick.
export default function SpotlightCard({ p, onNav }) {
  const { dispatch, wish, toggleWish, notify } = useStore();
  const [hovered, setHovered] = useState(false);
  const meta = CAT_META[p.category] || { emoji:"👗" };
  const disc = Math.round((1 - p.price / p.mrp) * 100);
  const wished = wish.includes(p.id);
  const GOLD = "#C9A24B";

  const addCart = (e) => {
    e.stopPropagation();
    dispatch({ type:"ADD", p:{ ...p, sc:p.colors?.[0]||"Default", ss:p.sizes?.[0]||"Free" } });
    notify(`${p.name} added!`);
    if (navigator.vibrate) navigator.vibrate(50);
  };

  return (
    <div
      onClick={()=>onNav("product", p.id)}
      onMouseEnter={()=>setHovered(true)}
      onMouseLeave={()=>setHovered(false)}
      style={{
        borderRadius:4, overflow:"hidden", cursor:"pointer", position:"relative",
        background:"white",
        border:`1px solid ${hovered?GOLD:"#eee"}`,
        boxShadow: hovered ? "0 22px 48px rgba(201,162,75,0.22)" : "0 4px 16px rgba(0,0,0,0.06)",
        transition:"all 0.4s ease",
      }}>
      {/* inner gold hairline frame */}
      <div style={{ position:"absolute", inset:8, border:`1px solid ${GOLD}55`, pointerEvents:"none", zIndex:2 }}/>

      <div style={{ padding:"20px 20px 0", display:"flex", alignItems:"center", gap:8 }}>
        <span style={{ color:GOLD, fontSize:13 }}>✦</span>
        <span style={{ fontSize:9, fontWeight:800, letterSpacing:3, color:GOLD, textTransform:"uppercase" }}>Featured</span>
      </div>

      <div style={{ height:280, margin:"14px 20px 0", position:"relative", overflow:"hidden" }}>
        {p.img
          ? <img src={p.img} alt={p.name} style={{ width:"100%", height:"100%", objectFit:"cover", objectPosition:"top", transition:"transform 0.6s ease", transform:hovered?"scale(1.06)":"scale(1)" }} loading="lazy"/>
          : <div style={{ width:"100%", height:"100%", background:meta.light||"#fafafa", display:"flex", alignItems:"center", justifyContent:"center", fontSize:56, opacity:0.25 }}>{meta.emoji}</div>
        }
        {disc > 0 && (
          <span style={{ position:"absolute", top:10, right:10, background:"white", color:"#1a1a2e", fontSize:10, fontWeight:800, padding:"4px 11px", border:`1px solid ${GOLD}`, letterSpacing:0.3 }}>
            {disc}% OFF
          </span>
        )}
        <button onClick={e=>{ e.stopPropagation(); toggleWish(p.id); if(navigator.vibrate)navigator.vibrate(30); }}
          style={{ position:"absolute", top:10, left:10, background:"white", border:"none", borderRadius:"50%", width:30, height:30, fontSize:14, cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", boxShadow:"0 2px 8px rgba(0,0,0,0.15)" }}>
          {wished ? "❤️" : "🤍"}
        </button>
      </div>

      <div style={{ padding:"16px 20px 22px", textAlign:"center" }}>
        <div style={{ fontSize:9, color:"#999", letterSpacing:2, textTransform:"uppercase", marginBottom:6 }}>{p.category}</div>
        <div style={{ fontFamily:"'Playfair Display',serif", fontSize:17, fontWeight:700, color:"#1a1a2e", marginBottom:8, lineHeight:1.3 }}>{p.name}</div>
        <div style={{ display:"flex", alignItems:"baseline", justifyContent:"center", gap:8, marginBottom:14 }}>
          <span style={{ fontSize:18, fontWeight:900, color:"#1a1a2e" }}>₹{p.price?.toLocaleString("en-IN")}</span>
          {p.mrp > p.price && <span style={{ fontSize:11, color:"#aaa", textDecoration:"line-through" }}>₹{p.mrp?.toLocaleString("en-IN")}</span>}
        </div>
        {p.stock > 0 ? (
          <button onClick={addCart} style={{ background:"none", border:`1px solid ${GOLD}`, color:"#8a6d2f", padding:"9px 26px", fontSize:11, fontWeight:700, letterSpacing:1, cursor:"pointer", textTransform:"uppercase" }}>
            Shop Now
          </button>
        ) : (
          <span style={{ fontSize:10, fontWeight:700, color:"#EF4444" }}>Out of Stock</span>
        )}
      </div>
    </div>
  );
}
